import styled, { css } from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, GhostButton } from 'react-components'

export const TitleContainer = styled.div(
    ({ theme }) => css`
        width: inherit;
        padding: 0.75rem 1rem 0.25rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: 0.75rem 1.5rem 0.25rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: 0.75rem 0 0.25rem;
        }
    `,
)

export const Title = styled.h2(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: 1.25rem;
        font-weight: 600;
        line-height: 1.75rem;
        color: #282828;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 1.563rem;
            line-height: 1.875rem;
        }
    `,
)

export const Subtitle = styled.p(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        font-weight: 400;
        line-height: 1.375rem;
        color: #5f5f5f;
        margin-top: 0.25rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: ${theme.typography.font.size.medium};
            line-height: 1.5rem;
        }
    `,
)

export const CtaContainer = styled.div`
    font-family: ${props => props.theme.typography.font.family.lato};
    display: flex;
    justify-content: flex-start;
    padding: 0 1rem;
    margin-top: 1.5rem;
    width: 100%;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 13.25rem;
        padding: 0 1.5rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0;
    }
`

export const StyledGhostButton = styled(GhostButton)(
    ({ theme }) => css`
        color: ${theme.colors.tfwBlack87};
        background-color: ${theme.colors.white};
        padding: 0.5rem 1.25rem;
        border-color: ${theme.colors.tfwBlack87};
        width: fit-content;
        width: 100%;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: 0.75rem 1.25rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: 0.75rem 3.563rem;
        }

        &:hover {
            background-color: ${theme.colors.tfwYellowHover};
            color: ${theme.colors.tfwBlack87};
            border-color: ${theme.colors.tfwYellowHover};
        }
    `,
)

export const CtaButtonText = styled.div`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.5rem;
    width: 100%;
    text-align: center;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 1rem;
    }
`
